// Required for page-description component fallback for Safari on ios 16 or lower

function checkOldIosFallback() {
    const userAgent = navigator.userAgent || '';
    const isIos16OrLower = /iPhone OS (1[0-6]|[0-9])_/i.test(userAgent) || /iPad OS (1[0-6]|[0-9])_/i.test(userAgent);
    if (isIos16OrLower) {
        document.body.classList.add('ios-fallback');
    }
}
checkOldIosFallback()  